/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Close_MenuInputs */

const cs_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zavřít menu`)
};

const en_nav_close_menu = /** @type {(inputs: Nav_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Nav_Close_MenuInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_close_menu = /** @type {((inputs?: Nav_Close_MenuInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Close_MenuInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_close_menu(inputs)
	return cs_nav_close_menu(inputs)
});